/**
 * Time-To jQuery plug-in
 * Show countdown timer or realtime clock
 *
 * @author Oleksii Teterin <altmoc@gmail.com>
 * @version 1.3.0
 * @license MIT http://opensource.org/licenses/MIT
 * @date 2019-05-14
 * @host https://github.com/Lexxus/jq-timeTo
 */
(function(factory) {
	typeof define == "function" && define.amd ? define(["jquery"], factory) : typeof exports == "object" ? module
		.exports = factory(require("jquery")) : factory(jQuery)
})(function($) {
	var SECONDS_PER_DAY = 86400,
		SECONDS_PER_HOUR = 3600,
		defaults = {
			callback: null,
			step: null,
			stepCount: 1,
			captionSize: 0,
			countdown: !0,
			countdownAlertLimit: 10,
			displayCaptions: !1,
			displayDays: 0,
			displayHours: !0,
			fontFamily: "Verdana, sans-serif",
			fontSize: 0,
			lang: "en",
			languages: {},
			seconds: 0,
			start: !0,
			theme: "white",
			width: 25,
			height: 30,
			gap: 11,
			vals: [0, 0, 0, 0, 0, 0, 0, 0, 0],
			limits: [9, 9, 9, 2, 9, 5, 9, 5, 9],
			iSec: 8,
			iHour: 4,
			tickTimeout: 1e3,
			intervalId: null,
			tickCount: 0
		},
		methods = {
			start: function(sec) {
				var intervalId;
				sec && (init.call(this, sec), intervalId = setTimeout(tick.bind(this), 1e3), this.data(
					"ttStartTime", $.now()), this.data("intervalId", intervalId))
			},
			stop: function() {
				var data = this.data();
				return data.intervalId && (clearTimeout(data.intervalId), this.data("intervalId", null)), data
			},
			reset: function(sec) {
				var data = methods.stop.call(this),
					secs = typeof sec == "undefined" ? data.seconds : sec;
				this.find("div").css({
					backgroundPosition: "left center"
				}), this.find("ul").parent().removeClass("timeTo-alert"), init.call(this, secs, !0)
			}
		},
		dictionary = {
			en: {
				days: "DAY",
				hours: "HRS",
				min: "MIN",
				sec: "SEC"
			},
			ru: {
				days: "\u0434\u043D\u0435\u0439",
				hours: "\u0447\u0430\u0441\u043E\u0432",
				min: "\u043C\u0438\u043D\u0443\u0442",
				sec: "\u0441\u0435\u043A\u0443\u043D\u0434"
			},
			ua: {
				days: "\u0434\u043Di\u0432",
				hours: "\u0433\u043E\u0434\u0438\u043D",
				min: "\u0445\u0432\u0438\u043B\u0438\u043D",
				sec: "\u0441\u0435\u043A\u0443\u043D\u0434"
			},
			de: {
				days: "Tag",
				hours: "Uhr",
				min: "Minuten",
				sec: "Secunden"
			},
			fr: {
				days: "jours",
				hours: "heures",
				min: "minutes",
				sec: "secondes"
			},
			es: {
				days: "d\xEDas",
				hours: "horas",
				min: "minutos",
				sec: "segundos"
			},
			sp: {
				days: "d\xEDas",
				hours: "horas",
				min: "minutos",
				sec: "segundos"
			},
			it: {
				days: "giorni",
				hours: "ore",
				min: "minuti",
				sec: "secondi"
			},
			nl: {
				days: "dagen",
				hours: "uren",
				min: "minuten",
				sec: "seconden"
			},
			no: {
				days: "dager",
				hours: "timer",
				min: "minutter",
				sec: "sekunder"
			},
			pt: {
				days: "dias",
				hours: "horas",
				min: "minutos",
				sec: "segundos"
			},
			tr: {
				days: "g\xFCn",
				hours: "saat",
				min: "dakika",
				sec: "saniye"
			},
			pl: {
				days: "dni",
				hours: "godziny",
				min: "minuty",
				sec: "secundy"
			}
		};
	typeof $.support.transition == "undefined" && ($.support.transition = function() {
		var thisBody = document.body || document.documentElement,
			thisStyle = thisBody.style,
			support = thisStyle.transition !== void 0 || thisStyle.WebkitTransition !== void 0 || thisStyle
			.MozTransition !== void 0 || thisStyle.MsTransition !== void 0 || thisStyle.OTransition !==
			void 0;
		return support
	}()), $.fn.timeTo = function() {
		var options = {},
			now = Date.now(),
			j, arg, num, method, time, days, tt, sec, m, t;
		for (j = 0; j < arguments.length; j += 1) arg = arguments[j], j === 0 && typeof arg == "string" ?
			method = arg : typeof arg == "object" ? typeof arg.getTime == "function" ? options.timeTo = arg :
			options = $.extend(options, arg) : typeof arg == "function" ? options.callback = arg : (num =
				parseInt(arg, 10), isNaN(num) || (options.seconds = num));
		if (options.timeTo) options.timeTo.getTime ? time = options.timeTo.getTime() : typeof options.timeTo ==
			"number" && (time = options.timeTo), time > now ? options.seconds = Math.floor((time - now) / 1e3) :
			options.seconds = 0;
		else if (options.time || !options.seconds) {
			if (time = options.time, time || (time = new Date(now)), typeof time == "object" && time.getTime)
				options.seconds = time.getDate() * SECONDS_PER_DAY + time.getHours() * SECONDS_PER_HOUR + time
				.getMinutes() * 60 + time.getSeconds(), options.countdown = !1;
			else if (typeof time == "string") {
				for (tt = time.split(":"), sec = 0, m = 1; tt.length;) t = tt.pop(), sec += t * m, m *= 60;
				options.seconds = sec, options.countdown = !1
			}
		}
		return options.countdown !== !1 && options.seconds > SECONDS_PER_DAY && typeof options.displayDays ==
			"undefined" ? (days = Math.floor(options.seconds / SECONDS_PER_DAY), options.displayDays = days <
				10 && 1 || days < 100 && 2 || 3) : options.displayDays === !0 ? options.displayDays = 3 :
			options.displayDays && (options.displayDays = options.displayDays > 0 ? Math.floor(options
				.displayDays) : 3), this.each(function() {
				var $this = $(this),
					data = $this.data(),
					defs, opt, i, css, language, left, ulhtml, style, dhtml1, dhtml2, dot2, maxWidth,
					captionSize, fsStyleVal, fsStyle, thtml, marginRight, dhtml, $digits, dif, vals, limits;
				if (data.intervalId && (clearInterval(data.intervalId), data.intervalId = null), data.vals)
					method !== "reset" && $.extend(data, options);
				else {
					if (data.opt ? opt = data.options : opt = options, defs = Object.keys(defaults).reduce(
							function(obj, key) {
								return Array.isArray(defaults[key]) ? obj[key] = defaults[key].slice(0) :
									obj[key] = defaults[key], obj
							}, {}), data = $.extend(defs, opt), data.options = opt, data.height = Math
						.round(data.fontSize * 100 / 90) || data.height, data.width = Math.round(data
							.fontSize * .6 + data.height * .13) || data.width, data.displayHours = !!(data
							.displayDays || data.displayHours), css = {
							fontFamily: data.fontFamily
						}, data.fontSize > 0 && (css.fontSize = data.fontSize + "px"), language = data
						.languages[data.lang] || dictionary[data.lang], $this.addClass("timeTo").addClass(
							"timeTo-" + data.theme).css(css), left = Math.round(data.height / 18), ulhtml =
						'<ul style="left:' + left + "px; top:-" + data.height +
						'px"><li>0</li><li>0</li></ul></div>', style = data.fontSize ? ' style="width:' +
						data.width + "px; height:" + data.height + 'px;"' : ' style=""', dhtml1 =
						'<div class="number_box"><div class="first"' + style + ">" + ulhtml, dhtml2 = "<div" + style + ">" + ulhtml + "</div>",
						dot2 = "<span>:</span>", maxWidth = 80, captionSize =
						data.captionSize || data.fontSize && Math.round(data.fontSize * .43), fsStyleVal =
						captionSize ? "font-size:" + captionSize + "px;" : "", fsStyle = captionSize ?
						' style="' + fsStyleVal + '"' : "", thtml = (data.displayCaptions ? (data
								.displayHours ? '<figure style="max-width:' + maxWidth +
								'px">$1<figcaption' + fsStyle + ">" + language.hours +
								"</figcaption></figure>" + dot2 : "") + '<figure style="max-width:' +
							maxWidth + 'px">$1<figcaption' + fsStyle + ">" + language.min +
							"</figcaption></figure>" + dot2 + '<figure style="max-width:' + maxWidth +
							'px">$1<figcaption' + fsStyle + ">" + language.sec + "</figcaption></figure>" :
							(data.displayHours ? "$1" + dot2 : "") + "$1" + dot2 + "$1").replace(/\$1/g,
							dhtml1 + dhtml2), data.displayDays > 0) {
						for (marginRight = Math.round(data.fontSize * .4 || defaults.gap), dhtml = dhtml1,
							i = data.displayDays - 1; i > 0; i -= 1) dhtml += i === 1 ? dhtml2.replace('">',
							"margin-right:" + marginRight + 'px">') : dhtml2;
						data.displayDays === 1 && (dhtml = dhtml.replace('">', "margin-right:" +
								marginRight + 'px">')), thtml = (data.displayCaptions ?
								'<figure style="width:' + (data.width * data.displayDays + marginRight +
								4) + 'px">$1<figcaption style="' + fsStyleVal + "padding-right:" +
								marginRight + 'px">' + language.days + "</figcaption></figure>" : "$1")
							.replace(/\$1/, dhtml) + thtml
					}
					$this.html(thtml)
				}
				if ($digits = $this.find(".number_box div"), $digits.length < data.vals.length) {
					for (dif = data.vals.length - $digits.length, vals = data.vals, limits = data.limits,
						data.vals = [], data.limits = [], i = 0; i < $digits.length; i += 1) data.vals[i] =
						vals[dif + i], data.limits[i] = limits[dif + i];
					data.iSec = data.vals.length - 1, data.iHour = data.vals.length - 5
				}
				data.sec = data.seconds, $this.data(data), method && methods[method] ? methods[method].call(
						$this, data.seconds) : data.start ? methods.start.call($this, data.seconds) : init
					.call($this, data.seconds)
			})
	};

	function init(sec, force) {
		var data = this.data(),
			$digits = this.find("ul"),
			isInterval = !1,
			days, rest, hours, minutes, secs, str, i, j, val;
		if (!(!data.vals || $digits.length === 0)) {
			for (sec || (sec = data.seconds), data.intervalId && (isInterval = !0, clearTimeout(data.intervalId)),
				days = Math.floor(sec / SECONDS_PER_DAY), rest = days * SECONDS_PER_DAY, hours = Math.floor((sec -
					rest) / SECONDS_PER_HOUR), rest += hours * SECONDS_PER_HOUR, minutes = Math.floor((sec - rest) /
					60), rest += minutes * 60, secs = sec - rest, str = (days < 100 ? "0" + (days < 10 ? "0" : "") :
					"") + days + (hours < 10 ? "0" : "") + hours + (minutes < 10 ? "0" : "") + minutes + (secs <
					10 ? "0" : "") + secs, i = data.vals.length - 1, j = str.length - 1; i >= 0; i -= 1, j -= 1)
				val = parseInt(str.substr(j, 1), 10), data.vals[i] = val, $digits.eq(i).children().html(val);
			(isInterval || force) && (data.ttStartTime = Date.now(), data.intervalId = setTimeout(tick.bind(this),
				1e3), this.data("intervalId", data.intervalId))
		}
	}

	function tick(digit) {
		var me = this,
			$digits = this.find("ul"),
			data = this.data(),
			n, $ul, $li, step, tickTimeout, timeDiff;
		if (!data.vals || $digits.length === 0) {
			data.intervalId && (clearTimeout(data.intervalId), this.data("intervalId", null)), data.callback && data
				.callback();
			return
		}
		typeof digit == "undefined" && (digit = data.iSec), this.data("tickCount", data.tickCount + 1), n = data
			.vals[digit], $ul = $digits.eq(digit), $li = $ul.children(), step = data.countdown ? -1 : 1, $li.eq(1)
			.html(n), n += step, typeof data.step == "function" && data.tickCount % data.stepCount === 0 && (this
				.data("tickCount", 0), data.step()), digit === data.iSec && (tickTimeout = data.tickTimeout,
				timeDiff = Date.now() - data.ttStartTime, data.sec += step, tickTimeout += Math.abs(data.seconds -
					data.sec) * tickTimeout - timeDiff, data.intervalId = setTimeout(tick.bind(this), tickTimeout)),
			n < 0 || n > data.limits[digit] ? (n < 0 ? (n = data.limits[digit], digit === data.iHour && data
				.displayDays > 0 && data.vals[digit - 1] === 0 && (n = 3)) : n = 0, digit > 0 && tick.call(this,
				digit - 1)) : !data.countdown && digit === data.iHour && data.displayDays > 0 && data.vals[digit -
				1] === 2 && data.vals[digit] === 3 && (n = 0, tick.call(this, digit - 1)), $li.eq(0).html(n), $
			.support.transition ? ($ul.addClass(""), $ul.css({
				top: 0
			}), setTimeout(function() {
				$ul.removeClass(""), $li.eq(1).html(n), $ul.css({
					top: "-" + data.height + "px"
				}), !(step > 0 || digit !== data.iSec) && (data.sec === data.countdownAlertLimit &&
					$digits.parent().addClass("timeTo-alert"), data.sec === 0 && ($digits.parent()
						.removeClass("timeTo-alert"), data.intervalId && (clearTimeout(data.intervalId),
							me.data("intervalId", null)), typeof data.callback == "function" && data
						.callback()))
			}, 410)) : $ul.stop().animate({
				top: 0
			}, 400, digit !== data.iSec ? null : function() {
				$li.eq(1).html(n), $ul.css({
					top: "-" + data.height + "px"
				}), !(step > 0 || digit !== data.iSec) && (data.sec === data.countdownAlertLimit ? $digits
					.parent().addClass("timeTo-alert") : data.sec === 0 && ($digits.parent().removeClass(
						"timeTo-alert"), data.intervalId && (clearTimeout(data.intervalId), me.data(
						"intervalId", null)), typeof data.callback == "function" && data.callback()))
			}), data.vals[digit] = n
	}
	return $
});
//# sourceMappingURL=/cdn/shop/t/161/assets/time-to.js.map?v=165751814929929832511694579486

